import { gql } from "@apollo/client";

const SAVE_SHOPIFY_CALLBACK = gql`
  mutation saveShopify($input: SaveShopify) {
    saveShopify(input: $input) {
      data
      status
      error
    }
  }
`;

export default SAVE_SHOPIFY_CALLBACK;
